import script from "./AiChatBot.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChatBot.vue?vue&type=script&setup=true&lang=js"

import "./AiChatBot.vue?vue&type=style&index=0&id=2da51bcc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da51bcc"]])

export default __exports__